import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { TimeFrame, TimeFrameGetAllRequestPayload } from './models/timeframe';

const timeFrameService = {
  getAll(payload: TimeFrameGetAllRequestPayload): Promise<CommonResponse<TimeFrame[]>> {
    let url = `/timeframes`;
    const params = new URLSearchParams();

    // Add parameters
    if (payload.sale_type_id) {
      params.append('sale_type_id', payload.sale_type_id.toString());
    }
    if (payload.eating_way_id) {
      params.append('eating_way_id', payload.eating_way_id.toString());
    }
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
    return axiosClient.get(url);
  },
};

export default timeFrameService;
